import {createContext, useContext} from "react";
import {MapTransform, ViewPort} from "@/encounter/model/ViewPort.ts";
import Size from "@/util/Size.ts";
import type Position from "@/util/Position.ts";

export type EncounterViewPortContextValue = {
    mapTransform: MapTransform;
    updateMapTransform: (transform: MapTransform) => void;
    resizeStage: (stageSize: Size) => void;
    persistCurrentViewPort: () => void;
    playerViewPort: ViewPort;
    playerViewPortLocked: boolean;
    togglePlayerViewPortLock: () => void;
    focusPlayerViewPort: () => void;
    focusWorldPosition: (position: Position) => void;
};

export const EncounterViewPortContext = createContext<EncounterViewPortContextValue | null>(null);

export function useEncounterViewPort(): EncounterViewPortContextValue {
    const context = useContext(EncounterViewPortContext);
    if (!context) throw new Error("useEncounterViewPort must be used within an EncounterViewPortProvider");
    return context;
}
